import { render, staticRenderFns } from "./FavNote.vue?vue&type=template&id=4c57b6a3"
import script from "./FavNote.vue?vue&type=script&lang=js"
export * from "./FavNote.vue?vue&type=script&lang=js"
import style0 from "./FavNote.vue?vue&type=style&index=0&id=4c57b6a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports